import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Box } from 'components/common/box';
import { StatItemWithIcon } from 'components/common/stats';

import type { AchievementDiscussionAnalysisResult } from 'shared-types';

interface Props {
  metadata: Pick<
    AchievementDiscussionAnalysisResult['metadata'],
    'numberOfAnswers' | 'numberOfQuestions' | 'numberOfUsers'
  >;
  numberOfKeyFindings: number;
}

const ConversationAnalysisStats = ({
  metadata,
  numberOfKeyFindings
}: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="stats">
      <div className="item">
        <Box>
          <StatItemWithIcon
            icon="user"
            label={messages.commonUsers}
            value={metadata.numberOfUsers}
          />
        </Box>
      </div>

      <div className="item">
        <Box>
          <StatItemWithIcon
            icon="file-lines"
            label={messages.commonQuestions}
            value={metadata.numberOfQuestions}
          />
        </Box>
      </div>

      <div className="item">
        <Box>
          <StatItemWithIcon
            icon="comment"
            label={messages.tasksAnswers}
            value={metadata.numberOfAnswers}
          />
        </Box>
      </div>

      <div className="item">
        <Box>
          <StatItemWithIcon
            icon="lightbulb"
            label={messages.achievementConversationAnalysesKeyFindings}
            value={numberOfKeyFindings}
          />
        </Box>
      </div>

      <style jsx>{`
        .stats {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 30px;
        }
        .item {
          width: 100%;
        }
        @media (min-width: ${breakpoints.small}px) {
          .item {
            width: calc(50% - 15px);
          }
        }
        @media (min-width: ${breakpoints.large}px) {
          .item {
            width: calc(25% - 22.5px);
          }
        }
      `}</style>
    </div>
  );
};

export default ConversationAnalysisStats;
